<div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
        <div class="d-flex align-items-center contact-title-wrapper">
            <img src="assets/svg/contract-icon.svg" width="20" class="contact-section-icon">
            <h3 class="text-semibold contact-title">Contratos</h3>
        </div>
        <div class="justify-self-end">
            <button class="action-btn primary">
                Crear nuevo contrato
            </button>
        </div>
    </div>
</div>

<div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
        <div class="d-flex align-items-center contact-title-wrapper">
            <img src="assets/svg/campaign-icon.svg" width="20" class="contact-section-icon">
            <h3 class="text-semibold contact-title">Campañas</h3>
        </div>
        <div class="justify-self-end">
            <button class="action-btn primary">
                Crear nueva campaña
            </button>
        </div>
    </div>
</div>